var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.classes }, [
    _c("div", { staticClass: "card h-100 card-events" }, [
      _c(
        "a",
        {
          staticClass: "d-block aspect-ratio-box aspect-ratio-box-16x9",
          attrs: { href: _vm.url, "aria-labelledby": _vm.title_id },
        },
        [
          _c("img", {
            staticClass: "aspect-ratio-box-inner object-fit-cover",
            attrs: { src: _vm.featured_img, alt: _vm.alt_text },
          }),
          _vm._v(" "),
          _vm.is_past
            ? _c("span", { staticClass: "event-past-label badge badge-dark" }, [
                _vm._v("Past Event"),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-body px-0 pb-0 pt-2 mt-4" }, [
        _c(
          "a",
          {
            staticClass: "d-block h6 card-title mb-0",
            attrs: { href: _vm.url, id: _vm.title_id },
          },
          [_vm._v(_vm._s(_vm.title))]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "card-link my-2" }, [
          _vm.location_title
            ? _c(
                "a",
                { staticClass: "btn btn-dark", attrs: { href: _vm.url } },
                [_vm._v(_vm._s(_vm.location_title))]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "card-text mb-2 mb-0" }, [
          _vm._v(_vm._s(_vm.street_address)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row event-datetime" }, [
          _c("div", { class: _vm.time_display ? "col-6" : "col-12" }, [
            _c("div", { staticClass: "event-date" }, [
              _vm._v(
                "\n                  " +
                  _vm._s(_vm.date_display) +
                  "\n                "
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.time_display
            ? _c("div", { staticClass: "col-6" }, [
                _c("div", { staticClass: "event-time" }, [
                  _vm._v(
                    "\n                  " +
                      _vm._s(_vm.time_display) +
                      "\n                "
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }